module.exports = __webpack_public_path__ + "img/bj_mx@2x.719fbcf5.png";